import React from "react";
import "./App.css";

export default function Footer() {
  return (
    <div className="open-source-code">
      This project was built by
      <a href="https://www.linkedin.com/in/priscillasalcedo/">
        {" "}
        Priscilla Salcedo
      </a>{" "}
      and open-sourced on
      <a href="https://github.com/pitisalcedo/weather-react"> Github</a>
    </div>
  );
}
